module.exports = __webpack_public_path__ + "img/grip3.7ff9999b.png";